import { render, staticRenderFns } from "./AppPromoFooter.vue?vue&type=template&id=01019b8e&scoped=true"
import script from "./AppPromoFooter.vue?vue&type=script&lang=js"
export * from "./AppPromoFooter.vue?vue&type=script&lang=js"
import style0 from "./AppPromoFooter.vue?vue&type=style&index=0&id=01019b8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01019b8e",
  null
  
)

export default component.exports